import React from 'react';
import cx from 'classnames';

import { IPageFields } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';

import { AffiliateHeader } from '../AffiliateHeader';
import { Navbar } from '../Navbar';
import { VariationContainer } from '../VariationContainer';

export function Headers({ headerType, hideHeader, hideBanner }: IPageFields) {
  const { config: { header } = {} } = usePageDataContext();

  // If page query returns 'headerType' data, show either regular Header... or Affiliate Header.
  // If page query returns 'contentfulGlobalConfig' data, show either: regular Header... or Variation Container
  const { sys, fields }: any = headerType ?? header ?? {};

  const contentType = sys?.contentType?.sys?.id;
  const isAffiliate = contentType === 'affiliateHeader';
  const showHeader = !hideHeader || !hideBanner;

  return (
    <header
      className={cx(
        'w-full top-0',
        {
          'hidden': !showHeader,
          'flex flex-col justify-center': showHeader,
          'relative': isAffiliate,
          'sticky z-[9999]': !isAffiliate
        }
      )}
      data-testid="fixed-header"
    >
      {!hideHeader &&
        (() => {
          switch (contentType) {
            case 'affiliateHeader':
              return <AffiliateHeader {...fields} />;

            case 'header2':
              return <Navbar {...fields} />;

            case 'variationContainer':
              return <VariationContainer {...fields} sysId={sys?.id} />;

            default:
              return null;
          }
        })()}
    </header>
  );
}
